import { useQuery } from '@tanstack/react-query';
import { fetchAgentModalKpiWidgets } from '@/lib/axios/api/widgets.api';

export function useAgentModalKpiWidgets(agentId: string | null | undefined, startDate: string | undefined, endDate: string | undefined, queueMicrosoftIds?: string[] | null) {
  const query = useQuery({
    queryKey: ['agentModalKpi', agentId, startDate, endDate, queueMicrosoftIds] as const,
    queryFn: ({ signal }) => fetchAgentModalKpiWidgets({ agentId, startTime: startDate, endTime: endDate, queueMicrosoftIds, signal }),
    enabled: !!agentId && !!startDate && !!endDate,
  });

  return {
    voicemail: query.data?.voicemail ?? 0,
    internal: query.data?.internal ?? 0,
  };
}
